export default __webpack_public_path__ + "static/media/Category_Paint_135x195.80695aeb.jpg";